<template>
  <v-container>
    <!-- Stack the columns on mobile by making one full-width and the other half-width -->
    <v-row>
      <v-col cols="12" md="8">
        <v-card class="pa-2" flat style="display:flex">
          <div>
            <h1>{{mainHeading}}</h1>
            <h2>{{sunHeading}}</h2>
            <h5>{{tagLine}}</h5>
          </div>
          <div>
            <img src="@/assets/email.png" alt="email" height="80px" />
          </div>
        </v-card>
         <v-card class="pa-2" flat>
          <SearchBar />
        </v-card>
      </v-col>
      <v-col cols="6" md="4">
        <v-card class="pa-2" flat><v-img src="@/assets/map_logo-Copy.png" /> </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import SearchBar from "@/pages/SearchBar.vue";
export default {
  name: "Search",
  data: () => ({
    mainHeading: "GeoAd Postcode Lookup",
    sunHeading: "Geolocation and addressing",
    tagLine:
      "integrating services from Royal Mail, what3words, Open Weather Map, and beyond."
  }),
  components: {
      SearchBar
  }
};
</script>
<style scoped>
.theme--light.v-card.v-card--outlined {
  border: thin solid rgba(0, 0, 0, 0);
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: Helvetica;
  color: #02083c;
  text-align: center;
  font-weight: bold;
}
h2 {
  font-size: large;
  font-weight: bold;
}
h5 {
  font-size: small;
  font-weight: 600;
}
</style>